/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import { Component, Prop, Vue } from 'vue-property-decorator';
import {LoadingStateInterface} from '@/components/Loading/types';

/**
 * Loading component.
 *
 * Component that provides a uniform loading component.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
@Component({
    name: 'c-loading',
})
export default class Loading extends Vue {
    @Prop(Object) public config!: LoadingStateInterface;

    /**
     * Loading getter.
     *
     * @returns {boolean}
     */
    get loading(): boolean {
        return !!this.config && this.config.loading;
    }

    /**
     * Text checker.
     *
     * @returns {boolean}
     */
    get hasText(): boolean {
        return !!this.config && !!this.config.textKey && this.config.textKey.length > 0;
    }

    /**
     * Get translated text.
     *
     * @returns {string}
     */
    get text(): string {
        if (undefined === this.config || undefined === this.config.textKey) {
            return '';
        }

        return this.$i18n.translate(this.config.textKey, {}) || '';
    }
}

